import { GBCountryCodes, USTerritoryCountryCodes } from '@sm/locale/dist/localeSets';

import { Packages } from '~shared/constants/pricing';
import { PackageSet, PackageType, RoutePackageMap } from '~shared/types/pricing/package';

export const EXTERNAL_SCRIPTS: readonly string[] = Object.freeze(['https://js.stripe.com/v3/']);

export const MONTHLY_PACKAGES: PackageSet = [
  Packages.StandardMonthly,
  Packages.AdvantageMonthly,
  Packages.PremierMonthly,
  Packages.FormsMonthly,
  Packages.Flex,
];

export const INDIVIDUAL_PACKAGES: PackageSet = [
  Packages.PremierAnnual,
  Packages.AdvantageAnnual,
  Packages.StandardMonthly,
  Packages.Basic,
];

export const INDIVIDUAL_PACKAGES_WITH_STARTER: PackageSet = [
  Packages.PremierAnnual,
  Packages.AdvantageAnnual,
  Packages.StarterAnnual,
  Packages.StandardMonthly,
  Packages.Basic,
];

export const INDIVIDUAL_PACKAGES_WITH_FORMS: PackageSet = [
  Packages.PremierAnnual,
  Packages.AdvantageAnnual,
  Packages.StarterAnnual,
  Packages.FormsAnnual,
  Packages.Basic,
];

export const INDIVIDUAL_PACKAGES_WITH_FORMS_REVERSED: PackageSet = [
  Packages.Basic,
  Packages.FormsAnnual,
  Packages.StarterAnnual,
  Packages.AdvantageAnnual,
  Packages.PremierAnnual,
];

export const INDIVIDUAL_PACKAGES_WITH_FORMS_PARTIAL: PackageSet = [
  Packages.PremierAnnual,
  Packages.AdvantageAnnual,
  Packages.StandardMonthly,
  Packages.FormsAnnual,
  Packages.Basic,
];

export const INDIVIDUAL_PACKAGES_WITH_FORMS_PARTIAL_REVERSED: PackageSet = [
  Packages.Basic,
  Packages.FormsAnnual,
  Packages.StandardMonthly,
  Packages.AdvantageAnnual,
  Packages.PremierAnnual,
];

// GROW-2792 PnP Refresh Packages
export const GROW_2792_PACKAGES: PackageSet = [
  Packages.Basic,
  Packages.FormsAnnual,
  Packages.AdvantageAnnual,
  Packages.PremierAnnual,
  Packages.Enterprise,
];

// For now, the educational package set is identical to what we show for
// individual details. That may change some day, though, so making an explicitly
// named set here in case that ever changes. The shallow copy is to prevent any
// unexpected results when doing equality checks elsewhere
export const EDUCATIONAL_PACKAGES: PackageSet = [...INDIVIDUAL_PACKAGES];

export const TEAMS_PACKAGES: PackageSet = [Packages.TeamAdvantage, Packages.TeamPremier, Packages.Enterprise];

export const SUITE_PRICING_PACKAGES: PackageSet = [
  Packages.AdvantageAnnual,
  Packages.TeamAdvantage,
  Packages.TeamPremier,
];

// As of 2023/05/09, only annual packages are eligible for stripe checkout
export const STRIPE_ELIGIBLE_PACKAGES: PackageSet = [
  Packages.AdvantageAnnual,
  Packages.PremierAnnual,
  Packages.TeamAdvantage,
  Packages.TeamPremier,
];

export const GUAC_COUNTRY_CODES = Object.freeze(['GB', 'US', 'AU', 'CA']);
export const STARTER_ENABLED_COUNTRIES = Object.freeze([...USTerritoryCountryCodes, ...GBCountryCodes, 'AU']);

export const COMPARISON_PACKAGES: Partial<Record<Packages, Packages>> = {
  [Packages.TeamAdvantage]: Packages.AdvantageAnnual,
  [Packages.TeamPremier]: Packages.PremierAnnual,
};

// A list of packages that should display highlighted
export const HIGHLIGHTED_PACKAGES = [Packages.AdvantageAnnual];

// these domains do not get hreflang tags added to their <head>
export const SKIP_HREF_LANG_TAGS = Object.freeze({
  'de.surveymonkey.com': true,
  'ru.surveymonkey.com': true,
});

// Package type(route) and comparison packages mapping
export const ROUTE_PACKAGE_MAP: RoutePackageMap = {
  [PackageType.Individual]: INDIVIDUAL_PACKAGES,
  [PackageType.Teams]: TEAMS_PACKAGES,
  [PackageType.Educational]: EDUCATIONAL_PACKAGES,
};
